import React from 'react'

export default function HighlightIcon({ color = null }) {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <path
        d="M0 20h17.708v-1.18H0V20zm3.83-5.508l1.493.996-.628.97H2.26l1.57-1.966zM2.11 17.64H5.34l1.284-1.988.622-.93c.17-.257.47-.393.757-.337.8.15 1.607-.23 2.007-.92L16 4.052c.42-.726.215-1.652-.47-2.11L13.003.256c-.684-.453-1.618-.29-2.12.37l-6.94 8.766c-.496.654-.534 1.55-.092 2.224.16.247.152.573-.018.83l-.607.91-1.98 2.483c-.27.335-.32.785-.134 1.172.188.386.57.627 1 .627z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
